import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex, Text } from "@chakra-ui/react";
import { Form as FormikForm, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { changeModal, closeModal } from "~/features/ModalWithState";
import { useGatheringsDeclineMutation } from "~/store/api";
import { useAppDispatch } from "~/store/hooks";

const validationSchema = Yup.object({
  slug: Yup.string().required("Required"),
});

interface Props {
  rsvped: boolean | null | undefined;
  slug: string;
  trackers: {
    unregisterModalCloseCta: () => void;
    unregisterModalConfirmationCta: (slug: string) => void;
  };
}

export const UnregisterConfirmationModalContent: FC<Props> = ({
  rsvped,
  slug,
  trackers,
}) => {
  const { t } = useTranslation();
  const [apiGatheringsDecline] = useGatheringsDeclineMutation();
  const dispatch = useAppDispatch();

  const initialValues = {
    slug: slug,
  };

  const handleClose = () => {
    trackers.unregisterModalCloseCta();
    dispatch(closeModal());
  };

  const onSubmit = async (): Promise<void> => {
    await apiGatheringsDecline({ slug });
    trackers.unregisterModalConfirmationCta(slug);
    dispatch(
      changeModal({ type: "unregisterFeedback", data: { rsvped, slug } }),
    );
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validateOnMount: true,
    validationSchema,
  });

  if (!rsvped) {
    return null;
  }

  return (
    <FormikProvider value={formik}>
      <FormikForm>
        <Flex align="center" direction="column" py={2} gap={5} w="full">
          <Text fontWeight="bold" px={16} textAlign="center" variant="th-body1">
            {t("rsvp.unregister.confirmation.heading")}
          </Text>
          <Flex direction="column" gap={3} w="full">
            <Button type="submit" size="th-md" variant="th-primary">
              {t("rsvp.unregister.confirmation.unregister")}
            </Button>
            <Button onClick={handleClose} size="th-md" variant="th-secondary">
              {t("rsvp.unregister.confirmation.cancel")}
            </Button>
          </Flex>
        </Flex>
      </FormikForm>
    </FormikProvider>
  );
};
